module.exports = __webpack_public_path__ + "img/example_globe.ef3e9892.png";